import React, { useState } from 'react';
import { get } from 'lodash-es';
import Container from 'reactstrap/lib/Container';
import Modal from 'reactstrap/lib/Modal';
import ModalBody from 'reactstrap/lib/ModalBody';
import { connectToModel } from 'client/data/luckdragon/redux/react-binding';
import { CmsEntities, bindToContent } from 'client/data/models/cms';
import { ContentFragment } from 'site-modules/shared/components/content-fragment/content-fragment';

import './executive-bios.scss';

export const EXECUTIVE_BIOS_CONTENT_FILE_PATH = '/about/executive-bios-new';

function extractLastParagraph(htmlContent) {
  if (!htmlContent) return '';
  const matches = htmlContent.match(/<p>[\s\S]*?<\/p>/gi);
  return matches ? matches[matches.length - 1] : '';
}

export function ExecutiveBiosUI({ content = null }) {
  const [expandedEntry, setExpandedEntry] = useState(null);

  if (!content) {
    return null;
  }

  const title = get(content, 'title', 'Executive Bios');
  const bios = content.child('main').children();

  return (
    <main id="main-content" tabIndex={-1} className="executive-bios pb-2">
      <Container>
        <h1 className="heading-2 mb-2">{title}</h1>
        <div className="executive-bios__grid row gy-2 gx-2">
          {bios.map(entry => {
            const image = entry.metadata('image').value();
            const name = entry.metadata('name').value();
            const position = entry.metadata('position').value();
            const htmlContent = entry.metadata('htmlContent').value();
            const carMemory = extractLastParagraph(htmlContent);

            return (
              <div key={entry.id} className="col-12 col-lg-6">
                <div className="executive-bios__card d-flex align-items-start gap-1">
                  <div className="executive-bios__photo-wrapper flex-shrink-0">
                    <img src={image} alt={name} className="executive-bios__photo" />
                  </div>
                  <div className="executive-bios__card-info d-flex flex-column gap-0_25 justify-content-center">
                    <p className="executive-bios__name mb-0">{name}</p>
                    <p className="executive-bios__position mb-0">{position}</p>
                    <button type="button" className="executive-bios__read-bio" onClick={() => setExpandedEntry(entry)}>
                      Read bio
                    </button>
                    {carMemory && (
                      <ContentFragment classes="executive-bios__car-memory mb-0">{carMemory}</ContentFragment>
                    )}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </Container>

      <Modal isOpen={!!expandedEntry} toggle={() => setExpandedEntry(null)} className="executive-bios__modal" centered>
        {expandedEntry && (
          <ModalBody className="executive-bios__modal-body">
            <button
              type="button"
              className="executive-bios__modal-close btn-close"
              onClick={() => setExpandedEntry(null)}
              aria-label="Close bio"
            />
            <div className="d-flex flex-column flex-lg-row align-items-start gap-1">
              <div className="executive-bios__photo-wrapper flex-shrink-0">
                <img
                  src={expandedEntry.metadata('image').value()}
                  alt={expandedEntry.metadata('name').value()}
                  className="executive-bios__photo"
                />
              </div>
              <div>
                <h2 className="heading-5 mb-1">
                  {expandedEntry.metadata('name').value()}, {expandedEntry.metadata('position').value()}
                </h2>
                <ContentFragment classes="executive-bios__modal-content">
                  {expandedEntry.metadata('htmlContent').value()}
                </ContentFragment>
              </div>
            </div>
          </ModalBody>
        )}
      </Modal>
    </main>
  );
}

ExecutiveBiosUI.propTypes = {
  content: CmsEntities.Content,
};

export const ExecutiveBios = connectToModel(ExecutiveBiosUI, {
  content: bindToContent(EXECUTIVE_BIOS_CONTENT_FILE_PATH),
});
